import React from "react";
import { Box, Stack, Paper, Typography } from "@mui/material";

interface ReferToEmailStepProps {
    email: string;
}

const ReferToEmailStep: React.FC<ReferToEmailStepProps> = ({ email }) => {
    return (
        <Box>
            <Stack spacing={2}>
                <Paper elevation={0} sx={{ p: 4, borderRadius: 0, m: 2, flexGrow: 1 }}>
                    <Typography color="info" align="center">
                        Er is een email verstuurd naar: <strong>{email}</strong><br/>Volg de instructies in je email <br/>Je kunt dit venster sluiten.
                    </Typography>
                </Paper>
            </Stack>
        </Box>
    );
};

export default ReferToEmailStep;